import { extractValue } from "../../../../../../libs/utils";

export function hasValue(value: unknown): boolean {
  const unwrapped = extractValue(value);
  if (unwrapped == null) return false;
  if (typeof unwrapped === "string") return unwrapped.trim() !== "";
  return true;
}
